<template>
  <div>
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang259') }}</span>
    </div>
    <div class="home_page" @scroll="handleScroll">
      <div class="pd goods_box" v-if="list.length > 0">
        <div class="goods_list jsb" v-for="(item, index) in list" :key="index">
          <div class="right" style="flex: 1">
            <span class="ellipsis name">{{ item.title }}</span>
            <span class="time_text t2">{{ dateFormatFn(item.start_time) }}-{{ dateFormatFn(item.end_time) }}</span>
            <div class="buy" @click="navigatorToPage('synthesisDetail', item.id)" v-if="current > item.start_time && current < item.end_time">
              <van-button class="buy_btn" type="primary">{{ $t('lang296') }}</van-button>
            </div>
            <div class="buy" v-else-if="current < item.start_time" @click="navigatorToPage('synthesisDetail', item.id)" >
              <van-button class="buy_btn will" type="primary">
                <span>
                  {{ $t('lang297') }}
                </span>
                <!-- <span class="countdown">24h13m25s</span> -->
                <van-count-down class="countdown" :time="(item.start_time - current) * 1000" format="HHhmmmsss" />
              </van-button>
            </div>
            <div class="buy" @click="navigatorToPage('synthesisDetail', item.id)" v-else-if="current > item.end_time">
              <van-button class="buy_btn finish" type="primary">{{ $t('lang74') }}</van-button>
            </div>
          </div>
          <van-image class="goods_list_img" radius="10" :src="item.img_url" />
        </div>
      </div>
      <div class="bare" v-else>
        <span>{{ $t('lang60') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import { Toast } from 'vant';
export default {
  data() {
    return {
      time: 30 * 60 * 60 * 1000,
      showLoading: true,
      list: [],
      page: 1,
      current: parseInt(new Date().getTime() / 1000), //1743648326
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    //返回上一页
    back() {
      if (window.history.length <= 1) {
      // 如果没有历史记录，可以跳转到默认页
        this.$router.replace('/'); 
      } else {
        this.$router.back();
      }
    },
    init() {
      this.getSynthesisList();
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'MM/dd hh:mm');
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        console.log('Bottom');
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.getSynthesisList(); // 触发加载更多
        }
      }
    },

    getSynthesisList() {
      homeApi.getSynthesisList({ sort: this.sort, type_id: this.type_id, key_val: this.key, page: this.page }).then(res => {
        if (res.code == 200) {
          if (this.list.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data];
            if (this.list.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },

    navigatorToPage(name, id) {
      this.$router.push({ name, query: { id: id } });
    },
  },
  computed: {
    ...mapState(['account']),
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.home_page {
  padding: 50px 0 100px;
  height: 100vh;
  overflow: auto;

  .pd {
    padding: 14px;
    // background-color: #fff;
  }

  .jsb {
    justify-content: space-between;
  }

  .goods_box {
    // margin: 14px;
    border-radius: 14px;
    .good_icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }

  .goods_list {
    display: flex;
    color: #000;
    // padding: 14px;
    border-radius: 10px;
    margin-bottom: 16px;
    background-color: #fff;
    &_img {
      width: 125px;
      height: 125px;
      border-radius: 0 10px 10px 0 !important;
    }
    /deep/.van-image {
      border-radius: 0 10px 10px 0 !important;
    }

    .right {
      width: calc(100% - 100px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 13px;
      padding: 14px;
      box-sizing: border-box;
      // padding: 6px 0;

      .name {
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .time_text {
        color: #7f7f7f;
        font-weight: normal;
        font-size: 10px;
        letter-spacing: 1px;
        text-decoration: line-through;
      }

      .t2 {
        text-decoration: none;
        white-space: nowrap;
        padding: 2px 0;
      }
    }
    .buy {
      display: flex;
      align-items: flex-end;
      &_btn {
        height: 30px;
        min-width: 102px;
        line-height: 26px;
        font-size: 12px;
        letter-spacing: 1px;
        text-align: center;
        white-space: nowrap;
        padding: 0 20px;
        border: none;
        border-radius: 30px;
        background-color: #29b286;
      }
      .will {
        background-color: #585858;
        .van-button__text {
          display: flex;
          align-items: center;
          flex-direction: column;
          line-height: 108%;
        }
        .countdown {
          font-size: 9px;
          letter-spacing: 0;
        }
        /deep/.van-count-down {
          line-height: 116% !important;
          color: #fff !important;
        }
      }
      .finish {
        color: #585858;
        background-color: #dedede;
      }
    }
  }
}
.bare {
  text-align: center;
  font-size: 14px;
  padding: 60px 14px;
  color: #888;
}
.flex {
  display: flex;
  align-items: center;
}
.flex_end {
  align-items: flex-end;
}
::v-deep .van-cascader__option {
  color: #000;
}
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>